"use client"

import { Navbar } from "@/components/navbar"
import { Footer } from "@/components/footer"
import { AdvancedSearch } from "@/components/advanced-search"
import { ArrowLeft } from "lucide-react"
import Link from "next/link"

export default function SearchPage() {
    return (
        <div className="flex min-h-screen flex-col">
            <Navbar />

            <main className="flex-1">
                <div className="container py-8">
                    {/* Header */}
                    <div className="mb-8">
                        <Link
                            href="/boutique"
                            className="inline-flex items-center gap-2 text-primary hover:underline mb-4"
                        >
                            <ArrowLeft size={20} />
                            Retour à la boutique
                        </Link>

                        <h1 className="text-3xl md:text-4xl font-bold text-foreground dark:text-dark-foreground mb-2">
                            Recherche avancée
                        </h1>
                        <p className="text-foreground-secondary dark:text-dark-foreground-secondary">
                            Utilisez les filtres pour affiner votre recherche et trouver exactement ce que vous cherchez
                        </p>
                    </div>

                    {/* Composant de recherche avancée */}
                    <AdvancedSearch />
                </div>
            </main>

            <Footer />
        </div>
    )
}
